/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useEffect} from 'react'
import {useIntl} from 'react-intl'
import { useSearchParams } from 'react-router-dom';



const SamlPage: FC = () => (
  
  <>
    {/* begin::Row */}
    <div className='row gy-5 g-xl-8'>
      <div className='col-xxl-4'>
        SAML RESPONSE
      </div>
    </div>    
  </>
)
/*<PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>*/
const SamlWrapper: FC = () => {
  const intl = useIntl()
  
  return (
    <>      
      <SamlPage />
    </>
  )
  
}

export {SamlWrapper}
